module.exports = __webpack_public_path__ + "static/img/解决方案定制.b0bae712.png";